import React, { Fragment, useRef, useState } from "react";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import CustomTable from "../../common/CustomTable/CustomTable";
import ActionBar from "../../common/ActionBar";
import _ from "lodash";
import queryString from "query-string";
import labels from "../../../helpers/labels.json";
import { useSnackbar } from "notistack";
import { getErrorMessage, parseTimeStamp } from "../../../helpers/functions";
import TranscriberService from "../../../services/TranscriberService";
import styled from "styled-components";
import moment from "moment";
import { navigate } from "@reach/router";
import useLoader from "../../../hooks/useLoader";
import TimeLine from "./component/Logs";
import axios from "axios";
import { PrimaryCTAButton } from "../../common/Buttons";
import { Tooltip } from "@material-ui/core";
import PreSignIn from "../ManagementTools/component/PreSignIn";
import {
  DeleteButtonContainer,
  DeleteIcon,
} from "../NeutalMeeting/component/ArbitratorMeeting";

async function getTranscriberList(query = "") {
  try {
    const response = await TranscriberService.getEsigner(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const EsignerTable = () => {
  const breadcrumbs = [_.startCase(labels.esigner)];
  const [state, setState] = useState({});
  const MTRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const placeholderText = "Search Esigner";
  const { setLoader } = useLoader();
  const [modal, setModal] = useState({ state: false });
  const [signIn, setSignIn] = useState({ state: false });

  async function updateEsigned(arbitratorId, data) {
    try {
      setLoader({ state: true, message: "Renew link" });
      const response = await TranscriberService.updateEsigned(
        arbitratorId,
        data,
      );
      if (response) {
        enqueueSnackbar("Link renewed successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
    }
  }

  const expiryTime = (updated_at) => {
    return (
      Date.now() > new Date(updated_at).getTime() + 5 * 24 * 60 * 60 * 1000
    );
  };

  async function auditLogs(
    transactionNumber,
    referenceNumber,
    name,
    esignerLogs,
    signedDate,
  ) {
    try {
      setLoader({ state: true, message: "logs..." });
      const audit_response = await axios.get(
        `https://emgateway.emsigner.com/api/TransactionStatusRequest?Authtoken=5a86eee6-79d4-4c50-83be-0aed299779d4&Transactionnumber=${transactionNumber}&Referencenumber=${referenceNumber}`,
      );
      if (audit_response.data.IsSuccess) {
        setModal({
          state: true,
          name: name,
          status: audit_response.data.Value.Status,
          message: audit_response.data.Value.ErrorMessage,
          timeLineData: JSON.parse(esignerLogs),
          signedDate: signedDate,
        });
      } else {
        setModal({
          state: true,
          name: name,
          status: "Initiated",
          message: "",
          timeLineData: JSON.parse(esignerLogs),
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader({ state: false });
    }
  }

  function updateUrl(originalUrl, fallbackUrl, internalReferenceNumber) {
    // Extract the filename from the original URL
    const parts = originalUrl.split("/");

    // Get the base path without the filename
    const basePath = parts.join("/");

    // Determine the new filename (without .pdf)
    let newFilenameBase;
    if (internalReferenceNumber && internalReferenceNumber.trim() !== "") {
      newFilenameBase = internalReferenceNumber;
    } else {
      const fallbackParts = fallbackUrl.split("/");
      const fallbackFilename = fallbackParts.pop(); // e.g., S019400575%20%20-%20MBE%20-%20Depository%20-%20Salary%20Attachment.pdf
      newFilenameBase = decodeURIComponent(
        fallbackFilename.replace(".pdf", ""),
      );
    }

    // Construct the new URL
    const newUrl = `${basePath}/${newFilenameBase}.pdf`;
    return getFileName(newUrl);
  }

  async function deleteEsignerLink(esignerId) {
    try {
      const response = await TranscriberService.deleteEsignerLink({
        id: esignerId,
      });
      enqueueSnackbar(response?.message, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {
        variant: "error",
      });
    } finally {
      MTRef.current.onQueryChange("");
    }
  }

  const actions = [
    {
      text: "Pre Sign In",
      props: {
        onClick: () => setSignIn({ state: true }),
      },
    },
  ];

  /*

  const previewAndDownload = async (url, fileName) => {
    if (!fileName) {
      fileName = url.split("\\").pop().split("/").pop();
    }

    fileName = decodeURIComponent(fileName);

    try {
      const res = await fetch(url);
      const blob = await res.blob();

      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Preview/Download failed", err);
    }
  };

  */

  function getFileName(uri) {
    if (!uri) return "";

    const parts = uri.split("/");
    const fileName = parts[parts.length - 1];

    return decodeURIComponent(fileName);
  }

  const columns = [
    {
      field: "arbitratorName",
      title: labels["profile_name"],
      sorting: false,
      render: (rowData) => (
        <Bold
          onClick={() =>
            navigate(`/dashboard/case-manager/transcriber/${rowData?.id}`)
          }
        >
          {rowData?.arbitratorName}
        </Bold>
      ),
    },
    {
      field: "arbitratorEmailId",
      title: labels["profile_email"],
      sorting: false,
    },
    {
      field: "created_at",
      title: labels["created_on"],
      sorting: false,
      render: (rowData) => (
        <>{moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}</>
      ),
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "updated_at",
      title: labels["updated_on"],
      sorting: false,
      render: (rowData) => (
        <>{moment(parseTimeStamp(rowData.updated_at)).format("DD/MM/YYYY")}</>
      ),
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "",
      title: "Status",
      sorting: false,
      render: (rowData) => (
        <>
          {rowData?.eSignedFile ? <Bold>Completed</Bold> : <Bold>Pending</Bold>}
        </>
      ),
      headerStyle: { textAlign: "center" },
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "esignerLogs",
      title: "Logs",
      sorting: false,
      render: (rowData) =>
        JSON.parse(rowData?.esignerLogs)?.length ||
        rowData?.Transactionnumber ||
        rowData?.Referencenumber ? (
          <HyperLink
            onClick={() =>
              auditLogs(
                rowData?.Transactionnumber,
                rowData?.Referencenumber,
                rowData?.arbitratorName,
                rowData?.esignerLogs,
                rowData?.signedDate,
              )
            }
          >
            Activity
          </HyperLink>
        ) : (
          <Bold style={{ marginLeft: 18 }}>-</Bold>
        ),
      headerStyle: { textAlign: "center" },
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "action",
      title: "Renew Link",
      sorting: false,
      render: (rowData) =>
        rowData?.eSignedFile ? (
          <Bold style={{ marginLeft: 35 }}>-</Bold>
        ) : expiryTime(rowData?.updated_at) ? (
          <HyperLink
            onClick={() =>
              updateEsigned(rowData?.arbitratorId, {
                updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
              })
            }
          >
            Renew link
          </HyperLink>
        ) : (
          <Bold style={{ marginLeft: 35 }}>- </Bold>
        ),
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "eSignedFile",
      title: "Signed File",
      sorting: false,
      render: (rowData) =>
        rowData?.eSignedFile ? (
          <Tooltip
            title={updateUrl(
              rowData?.eSignedFile,
              rowData?.fileBase64,
              rowData?.internalReferenceNumber,
            )}
            placement="top"
          >
            <HyperLink
              style={{ width: 95 }}
              /*
              onClick={() =>
                previewAndDownload(
                  rowData?.eSignedFile,
                  rowData?.internalReferenceNumber
                    ? rowData?.internalReferenceNumber
                    : getFileName(rowData?.fileBase64),
                )
              }
              */
              onClick={() => window.open(rowData?.eSignedFile)}
            >
              {updateUrl(
                rowData?.eSignedFile,
                rowData?.fileBase64,
                rowData?.internalReferenceNumber,
              )}
            </HyperLink>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              rowData?.internalReferenceNumber
                ? rowData?.internalReferenceNumber
                : getFileName(rowData?.fileBase64)
            }
            placement="top"
          >
            <HyperLink
              style={{ width: 95 }}
              onClick={() => window.open(rowData?.fileBase64)}
            >
              {rowData?.internalReferenceNumber
                ? rowData?.internalReferenceNumber
                : getFileName(rowData?.fileBase64)}
            </HyperLink>
          </Tooltip>
        ),
      headerStyle: { textAlign: "center" },
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },

    {
      field: "",
      title: "Link",
      sorting: false,
      render: (rowData) => (
        <PrimaryCTAButton
          style={{
            margin: 0,
            height: 30,
            width: "auto",
            borderRadius: 10,
            marginLeft: 28,
          }}
          onClick={() => {
            navigator.clipboard.writeText(rowData?.eSignerLink);
            enqueueSnackbar("Link copied successfully", {
              variant: "success",
            });
          }}
        >
          Copy
        </PrimaryCTAButton>
      ),
      headerStyle: { textAlign: "center" },
    },
    {
      field: "actions",
      title: "Action",
      sorting: false,
      render: (rowData) =>
        rowData?.eSignedFile ? null : (
          <DeleteButtonContainer
            onClick={() => deleteEsignerLink(rowData.id)}
            title="Remove link"
          >
            <DeleteIcon>✕</DeleteIcon>
          </DeleteButtonContainer>
        ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      if (query?.search) {
        params.query = query?.search;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getTranscriberList(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <Fragment>
      <ActionBar {...{ breadcrumbs }} {...{ actions }} />
      <Padding>
        <CustomTable
          hidePagination={state.lastPage === 1}
          pageSize={state?.data?.length ? state?.data?.length : 10}
          pluralTitle={labels.case_manager}
          hideFilterBar
          singularTitle=""
          {...{
            columns,
            data,
            MTRef,
            placeholderText,
          }}
          // noToolbar
          // hideFilterBar
          state={state}
        />
      </Padding>
      {modal?.state && <TimeLine {...{ modal, setModal }} />}
      {signIn?.state && <PreSignIn {...{ signIn, setSignIn, MTRef }} />}
    </Fragment>
  );
};

export default EsignerTable;

export const Padding = styled.div`
  padding-top: 30px;
  padding-bottom: 50px;
  padding-left: 35px;
  padding-right: 53px;
`;

const HyperLink = styled.span`
  cursor: pointer;
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontSemiBold};
  text-decoration: underline;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
`;

const Bold = styled.span`
  cursor: pointer;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
